import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  & > div {
    margin-bottom: 12px;
  }
`;

export const SelectTabContainer = styled.div`
  background: #fff;
  width: calc(100% - 60px);
  padding: 0px 30px 40px 30px;
`;
export const SelectTabWrapper = styled.div`
  width: calc(100% - 2px);
  height: 47px;
  border: 1px solid #78818e;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedTab = styled.div`
  cursor: pointer;
  flex: 1;
  height: 100%;
  background: #fff;
  color: #373f4c;

  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.isSelected &&
    css`
      background: #78818e;
      color: #fff;
      font-weight: bold;
    `};
`;
